import { ROUTES } from '~/components/router';

export const homeUrl = process.env.REACT_APP_HOME_URL ?? 'https://ome.health';
export const loginUrl = ROUTES.LOGIN;
export const helpUrl = process.env.REACT_APP_INTERCOM_HELP_URL ?? '';